import axios from './axios'
import qs from "qs";

function service() {

    function interactions(data = {}) {
        return axios.get(`interactions`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        interactions
    }
}

export default service
